import React, {useEffect} from 'react'
import Cookies from "js-cookie";
import {axiosInstance} from "../utilities/AxiosConfig";
import {useSpinner} from "../context/SpinnerContext";

// Run once per day per user(+db)
const getTodayKey = () => new Date().toISOString().slice(0, 10); // YYYY-MM-DD

const FirstRun = ({ enabled = true }) => {
    const {loading, setLoading} = useSpinner();

    useEffect(() => {
        if (!enabled) return;

        const user = Cookies.get("user") || "NoUser";
        const db = Cookies.get("database") || "DefaultDB";
        const today = getTodayKey();

        const storageKey = `firstRun:lastSuccess:${db}:${user}`;
        const lastSuccess = localStorage.getItem(storageKey);

        // already executed today for this user
        if (lastSuccess === today) return;

        let cancelled = false;

        (async () => {
            try {
                setLoading(true);
                await axiosInstance.get("purchase/post/all");
                if (!cancelled) {
                    localStorage.setItem(storageKey, today);
                }
            } catch (e) {
                // keep it NOT marked as success; it will try again next login/open
                console.error("FirstRun failed:", e);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [enabled, setLoading]);

    if (!loading) return null;

    return (
        <div style={{ padding: 12 }}>
            <div>Posting Pending Purchase</div>
        </div>
    );
};

export default FirstRun;
